import React from 'react'

const About = (props) => (
  <div>
    <p>This is Tripmaker, a platform/web application to WHOCARES</p>
  </div>
)

export default About